import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const ScopeSign = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 19 19">
      <g transform="matrix(1 0 0 1 -419 -1595 )">
        <path
          d="M 12.9545454545455 9.5  C 12.9545454545455 7.59136363636364  11.4086363636364 6.04545454545455  9.5 6.04545454545455  C 7.59136363636364 6.04545454545455  6.04545454545455 7.59136363636364  6.04545454545455 9.5  C 6.04545454545455 11.4086363636364  7.59136363636364 12.9545454545455  9.5 12.9545454545455  C 11.4086363636364 12.9545454545455  12.9545454545455 11.4086363636364  12.9545454545455 9.5  Z M 19 8.63636363636364  L 17.2209090909091 8.63636363636364  C 16.8236363636364 5.035  13.965 2.17636363636364  10.3636363636364 1.77909090909091  L 10.3636363636364 0  L 8.63636363636364 0  L 8.63636363636364 1.77909090909091  C 5.035 2.17636363636364  2.17636363636364 5.035  1.77909090909091 8.63636363636364  L 0 8.63636363636364  L 0 10.3636363636364  L 1.77909090909091 10.3636363636364  C 2.17636363636364 13.965  5.035 16.8236363636364  8.63636363636364 17.2209090909091  L 8.63636363636364 19  L 10.3636363636364 19  L 10.3636363636364 17.2209090909091  C 13.965 16.8236363636364  16.8236363636364 13.965  17.2209090909091 10.3636363636364  L 19 10.3636363636364  L 19 8.63636363636364  Z M 15.5454545454545 9.5  C 15.5454545454545 12.8379545454545  12.8379545454545 15.5454545454545  9.5 15.5454545454545  C 6.16204545454545 15.5454545454545  3.45454545454545 12.8379545454545  3.45454545454545 9.5  C 3.45454545454545 6.16204545454545  6.16204545454545 3.45454545454545  9.5 3.45454545454545  C 12.8379545454545 3.45454545454545  15.5454545454545 6.16204545454545  15.5454545454545 9.5  Z "
          fillRule="nonzero"
          fill="#61c69e"
          stroke="none"
          transform="matrix(1 0 0 1 419 1595 )"
        />
      </g>
    </SvgIcon>
  );
};

export default ScopeSign;
